<template>
  <div>
      <v-flex xs12 sm12 lg12 xl12>
        <v-card>
          <v-toolbar dense color="secondary" dark>
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              placeholder="Search roles"
              v-model="roleSearchString"
            ></v-text-field>
          </v-toolbar>
          <v-layout>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <RoleList :search="roleSearchString" :accountID="accountID"/>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
  </div>
</template>

<script>
import JWT from "jsonwebtoken";
import RoleList from "@/components/common/roles/role-list";

export default {
  data() {
    return {
      roleSearchString: null,
      accountID: null
    };
  },
  created() {
    this.GetAccount();
  },
  components: {
    RoleList
  },
  methods: {
    GetAccount() {
      let self = this;

      let tokenData = JWT.decode(localStorage["refreshToken"]);
      self.accountID = tokenData.ACCOUNT_ID;
    }
  }
};
</script>

<style>
</style>